import { render, staticRenderFns } from "./FlagIcon.vue?vue&type=template&id=43124dd1&scoped=true&"
import script from "./FlagIcon.vue?vue&type=script&lang=js&"
export * from "./FlagIcon.vue?vue&type=script&lang=js&"
import style0 from "./FlagIcon.vue?vue&type=style&index=0&id=43124dd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43124dd1",
  null
  
)

export default component.exports